export abstract class BaseService {

    constructor(props?: any) {
    }
}